import { render, staticRenderFns } from "./TimeQuestion.vue?vue&type=template&id=3e85596c&scoped=true"
import script from "./TimeQuestion.vue?vue&type=script&lang=js"
export * from "./TimeQuestion.vue?vue&type=script&lang=js"
import style0 from "./TimeQuestion.vue?vue&type=style&index=0&id=3e85596c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e85596c",
  null
  
)

export default component.exports